import FollowUpAgenciamentoConsultPageBase from './FollowUpAgenciamentoConsultPageBase';
import { FOLLOWUP_FILTROS } from '../followUpAgenciamentoFixedFilters';

export default function FollowUpAgenciamentoConsultExportAereoPage(props) {
  return (
    <FollowUpAgenciamentoConsultPageBase
      {...props}
      filtrosFixos={FOLLOWUP_FILTROS.EXPORT_AEREO}
      urlNovo="/exportacao/agenciamento/aereo/follow-up/registro/novo"
      urlDetalhes={(id) => `/exportacao/agenciamento/aereo/follow-up/${id}/detalhes`}
      urlLista={(id) => `/exportacao/agenciamento/aereo/follow-up/${id}/lista`}
      breadcrumbModulo={{
        name: 'Exportação Agenciamento Aéreo',
        to: '/exportacao/agenciamento/aereo',
      }}
    />
  );
}
